import { memo, ChangeEventHandler, useRef, useCallback } from 'react';
import classNames from 'classnames';

import { ReactComponent as CheckmarkIcon } from 'assets/images/checkmark.svg';

import styles from './styles.module.scss';

type Props = {
  name: string;
  label: string;
  checked: boolean;
  className?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
};

export const Checkbox: React.FC<Props> = memo(function Checkbox({
  name,
  label,
  checked,
  className,
  onChange,
}) {
  const nativeCheckboxRef = useRef<HTMLInputElement>(null);

  const handleCheckboxClick = useCallback(() => {
    nativeCheckboxRef.current?.click();
  }, []);

  return (
    <div
      className={classNames(styles.container, { [styles.checked_container]: checked }, className)}
      onClick={handleCheckboxClick}>
      <div>{checked && <CheckmarkIcon />}</div>
      <p>{label}</p>
      <input
        ref={nativeCheckboxRef}
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
      />
    </div>
  );
});
